
const userprofileview = [{"key":"userprofile.flash.ispublished","string":"Twój profil jest publikowany na platformie eksperckiej."},{"key":"userprofile.flash.unpublish","string":"Kliknij, aby cofnąć publikowanie."},{"key":"userprofile.flash.isnotpublished","string":"Twój profil nie jest publikowany na platformie eksperckiej."},{"key":"userprofile.flash.publish","string":"Kliknij, aby opublikować."}]

export default userprofileview



// WEBPACK FOOTER //
// ./src/i18n/pl/adduserprofile/userprofileview.js